import request from '@/util/request';

// 获取列表
export const getList = (params, options) =>
  request.get(
    '/api/v4ward/business-manage/list',
    Object.assign({}, options, { params })
  );

// 获取详情
export const getDetail = (params, options) =>
  request.get(
    '/api/v4ward/business-manage/detail',
    Object.assign({}, options, { params })
  );
